import { useEffect } from "react";
import { useSingleNicheQuery } from "@/common/queries/queries";
import { useNichesStore } from "@/common/store/storeNiches";

interface IUseCachedNiche {
  niche: string;
}

export const useCachedNiche = ({ niche }: IUseCachedNiche) => {
  const currentNiche = useNichesStore(state => state.getNiche(niche));
  const updateNiches = useNichesStore(state => state.updateNiches);

  const { isLoading, isSuccess, data, error } = useSingleNicheQuery(niche, !currentNiche);

  useEffect(() => {
    if (isSuccess && data) {
      updateNiches([data]);
    }
  }, [isSuccess, data]);

  return {
    niche: currentNiche,
    isLoading,
    error,
  };
};
